import { createContext, useContext } from 'react';

const StateContext = createContext(null);

// Local Context
const PropertyContext = createContext(null);
const InventoryContext = createContext(null);
const TenancyContext = createContext(null);

const useRootState = () => useContext(StateContext);
const useAuthState = () => useRootState().authState;
const useUIState = () => useRootState().uiState;
const useDate = () => useRootState().dateState;
const useUserLocation = () => useRootState().userLocationState;

const useProfile = () => useRootState().userDataState.profile;
const usePublicAccount = () => useRootState().userDataState.publicAccount;
const useEmailVerification = () => useRootState().emailVerificationState;
const useProperties = () => useRootState().userDataState.state.properties;
const useTenancies = () => useRootState().userDataState.state.tenancies;
const useNotices = () => useRootState().userDataState.notices;
const usePayments = () => useRootState().userDataState.payments;
const useSavedProperties = () => useRootState().userDataState.savedProperties;
const useSubscription = () => useRootState().userDataState.state.subscription;
const useRecentProperties = () => useRootState().userDataState.recentProperties;
const useStats = () => useRootState().userDataState.state.stats;

const useDataActions = () => useRootState().dataActions;

// Local context
const useProperty = () => useContext(PropertyContext);
const usePropertyTenancies = () => useProperty().tenancies;
const useTenancy = () => useContext(TenancyContext);
const useInventory = () => useContext(InventoryContext);

export {
  StateContext,
  PropertyContext,
  InventoryContext,
  TenancyContext,
  useRootState,
  useProfile,
  useUIState,
  useAuthState,
  usePublicAccount,
  useEmailVerification,
  useProperties,
  useTenancies,
  useProperty,
  usePropertyTenancies,
  useTenancy,
  useInventory,
  useDataActions,
  useNotices,
  usePayments,
  useUserLocation,
  useRecentProperties,
  useSavedProperties,
  useSubscription,
  useStats,
  useDate,
};
